// ─── Decision Type ────────────────────────────────────────────────────────────

export const decisionTypeLabels = {
  strategy:   "Strategy",
  finance:    "Finance",
  governance: "Governance",
  operations: "Operations",
  personnel:  "Personnel",
  compliance: "Compliance",
};

export const decisionTypeColors = {
  strategy:   "bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300",
  finance:    "bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300",
  governance: "bg-purple-100 text-purple-800 dark:bg-purple-900/50 dark:text-purple-300",
  operations: "bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300",
  personnel:  "bg-pink-100 text-pink-800 dark:bg-pink-900/50 dark:text-pink-300",
  compliance: "bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300",
};

// ─── Expected Outcome ─────────────────────────────────────────────────────────

export const expectedOutcomeLabels = {
  decision:    "Formal Decision",
  resolution:  "Resolution",
  approval:    "Approval",
  discussion:  "Discussion Only",
  information: "Information Only",
};

// ─── Decision Status ──────────────────────────────────────────────────────────

export const decisionStatusLabels = {
  pending:  "Pending",
  approved: "Approved",
  rejected: "Rejected",
  deferred: "Deferred",
  noted:    "Noted",
};

export const decisionStatusColors = {
  pending:  "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900/30 dark:text-yellow-300",
  approved: "bg-green-100 text-green-800 border-green-300 dark:bg-green-900/30 dark:text-green-300",
  rejected: "bg-red-100 text-red-800 border-red-300 dark:bg-red-900/30 dark:text-red-300",
  deferred: "bg-gray-100 text-gray-700 border-gray-300 dark:bg-gray-800/50 dark:text-gray-300",
  noted:    "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900/30 dark:text-blue-300",
};
